import request from 'axios';
import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import moment from 'moment';

/* ACTIONS
================================================================================================ */
const FETCH_MESSAGES = 'crowdspring/message/FETCH';
const FETCH_MESSAGES_REQUEST = 'crowdspring/message/FETCH_REQUEST';
const FETCH_MESSAGES_SUCCESS = 'crowdspring/message/FETCH_SUCCESS';
const FETCH_MESSAGES_FAILURE = 'crowdspring/message/FETCH_FAILURE';

/* HELPERS
================================================================================================ */

/* Create a new message */
export const createMessageRequest = (streamId, data, wrapup, project) => {
  const reqData = wrapup? { ...data, wrapup: wrapup.award.id } : { ...data, project: project.id };
  return request.post(
    `/api/v1/messages/${streamId}/create_${wrapup? 'wrapup':'project'}_message/`, reqData
  );
}

/* Group messages that by thread */
const groupByThread = (messages) => {
  const threads = []
  const msgThreadMap = {}

  /* go through the messages in reverse order (older first) so that threads can be built */
  reverse(messages).map((msg) => {
    /* message will belong to same thread as the one it's replying to */
    let threadIdx = msgThreadMap[msg['reply_to']]

    /* if there is no reply-to message or it was deleted, `threadIdx` won't be defined,
       so just add a new thread to the list */
    if (threadIdx === undefined) {
      threads.push([])
      threadIdx = threads.length - 1
    }

    msgThreadMap[msg.id] = threadIdx

    /* newer messages must come last in the thread */
    threads[threadIdx] = threads[threadIdx].concat([msg])
  })

  /* return sorted threads such that threads with most recent updates come first */
  return sortBy(threads, (t) => -moment(t.slice(-1)[0]['created_at']).toDate())
}

/* REDUCERS
 ================================================================================================ */
const initialState = {
  threads: [],
  fetching: false,
  streamId: null
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MESSAGES_REQUEST:
      return {
        ...state,
        fetching: true,
        streamId: action.streamId
      }
    case FETCH_MESSAGES_FAILURE:
      return {
        ...state,
        fetching: false,
        streamId: null,
        threads: []
      }
    case FETCH_MESSAGES_SUCCESS:
      /* only consider latest `state.streamId` if multiple actions were dispatched */
      if (action.streamId !== state.streamId) {
        return {
          ...state
        };
      }

      return {
        ...state,
        fetching: false,
        threads: groupByThread(action.payload.messages),
      };
    default:
      return state;
  }
}

/* ACTION CREATORS
 ================================================================================================ */
export const fetchMessagesIfNeeded = ({
  streamId, force, project, wrapup, wrapupStep
}) => (dispatch, getState) => {
  const { message } = getState();
  /* if not provided, consider current `streamId` */
  streamId = streamId || message.streamId;

  if (!(project || wrapup)) {
    return Promise.resolve();
  }

  const url = (
    wrapup?
    `/api/v1/wrapups/${wrapup.award.id}/messages/?step=${wrapupStep}` :
    `/api/v1/projects/${project.id}/messages/`
  );

  if (message.streamId != streamId || force) {
    return dispatch({
      type: FETCH_MESSAGES,
      streamId: streamId,
      promise: request({ method: 'get', url })
    });
  }

  return Promise.resolve();
}

export const updateMessage = (messageId, data, wrapup, wrapupStep) => (dispatch, getState) => {
  const { streamId } = getState().message;
  const promise = request.patch("/api/v1/messages/edit_message/", { message: messageId, ...data });
  promise.then(() => dispatch(fetchMessagesIfNeeded({
    force: true,
    wrapup,
    wrapupStep,
    streamId,
  })));
  return promise;
}

export const deleteMessage = (messageId, wrapup, wrapupStep) => (dispatch, getState) => {
  const { streamId } = getState().message;
  const promise = request.patch("/api/v1/messages/delete_message/", { message: messageId });
  promise.then(() => dispatch(fetchMessagesIfNeeded({
    force: true,
    wrapup,
    wrapupStep,
    streamId,
  })));
  return promise;
}



// WEBPACK FOOTER //
// ./common/ducks/message.js